import React, { useState } from 'react';
import { Grid, Typography, Breadcrumbs } from '@mui/material';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import {Waypoint} from 'react-waypoint'
import Testimonial from '../testimonial';
// import ProjectSlick from '../projects';
import FootPrint from '../../footprint';

const FireFighting = () => {

    const [numberBool, setNumberBool] = useState(false);

    const slides = [
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/firefighting/bitsmum-f.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>BITSoM, Mumbai </Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Mumbai, Maharashtra </Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/firefighting/exec-f.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>Executive Enclave , PMO House</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>New Delhi</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/firefighting/goa-f.png' alt='Goa Airport' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>MOPA International Airport</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Goa</Typography>
        </Grid>
        
    ]

return (
    <Grid item xs={12} sx={{width:'100%'}}>
        <Grid item xs={12} sx={{display: 'flex', flexFlow: 'column', alignItems:'center'}}>
            <Grid item className='title-div'
                // sx={{px:10, width:'100%', maxWidth:1440, display:'flex', justifyContent:'center', pt:'2em'}}
            >
                <Grid item sx={{px:!isMobile && 12.5, background: !isMobile && 'url(/assets/images/hvacbg.png) no-repeat', backgroundPosition:'bottom right'}}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to={'/'} className='normal-text title-color' style={{textDecoration:'none'}} >Home</Link>
                        <Link to={'/services'} className='normal-text title-color' style={{textDecoration:'none'}} >Services</Link>
                        <Typography variant='body2' component={'p'} sx={{color:'#535353'}}>Firefighting</Typography>
                    </Breadcrumbs>
                    <Grid item xs={12} sx={{pt:'2em',pb:'8em'}}>
                        <Typography variant='body2' component={'h5'} className='titleStyle title-color' sx={{ pb:2}}></Typography>
                       {/* <Typography variant='body2' component={'p'} className='normal-text' sx={{mb:4, lineHeight:2}}>
                            We have taken a step forward by adding firefighting services to our array of offerings. Capitalizing on our extensive experience in delivering top-notch piping solutions through our HVAC team, venturing into firefighting services has been a natural progression for us.
                        <br/><br/>
                            We understand that fire safety is non-negotiable. We utilize high-quality solutions sourced from available globally, enabling us to provide reliable and efficient fire safety systems that comply with industry standards and regulations. By combining firefighting services with HVAC and electrical services, we simplify the process for our business partners. This integrated approach streamlines coordination efforts and eliminates potential conflicts, leading to better project execution and smoother workflows.
                            <br/><br/>
                            What sets us apart
                        </Typography>
                        <ul>
                            <li className='normal-text' sx={{mb:2, lineHeight:2}}>Utilization of high-quality solutions from the international market to ensure reliable and efficient fire safety systems</li>
                            <li className='normal-text' sx={{mb:2, lineHeight:2}}>Integration of fire fighting, HVAC, and electrical services streamlines coordination for clients, architects and others</li>
                            <li className='normal-text' sx={{mb:2, lineHeight:2}}>With a one-stop solution for MEP needs, project workflows are smooth, leading to efficiency and cost effective implementation.</li>
                        </ul>*/}

                        <div className='cussec newcussecn1'>
                       <>
  <section class="mep-content">
   
   <h1><b>Industrial Fire Fighting Contractors In India</b></h1>

<p>
A fire safety system reveals its strength only during a real emergency. Every decision before installation shapes outcomes during those critical minutes. Factories, hospitals, warehouses, and campuses need planning that respects human movement and operational pressure.
</p>

<p>
At <a href="https://www.uniqueengineersltd.com/"><b>Unique Engineers</b></a>, we approach fire safety as a living system, not static hardware. Each project reflects risk understanding, compliance discipline, and long term operational reliability.
</p>

<h2><b>Why Industrial Fire Environments Demand Specialised Planning</b></h2>

<p>
Industrial spaces hold complex ignition risks and dense human activity. Heavy machinery, volatile materials, and continuous operations create layered fire exposure. A standard approach fails under such conditions. Industrial fire safety needs precision design and disciplined execution.
</p>

<p>
At Unique Engineers, we studied production flow, material behaviour, and evacuation realities. The team maps hazards before recommending suppression or detection systems. This method reduces panic and system failure during real incidents. Clients gain confidence through preparedness rather than dependence on alarms alone.
</p>

<h2><b>Fire Fighting Contractors In India With Grounded Engineering Thinking</b></h2>

<p>
<b>Fire fighting contractors in India</b> must balance regulation with practical site realities. At Unique Engineers, we build systems that pass inspections and perform under pressure. The approach respects Indian codes, international benchmarks, and local site constraints.
</p>

<p>
Every project begins with a structured risk assessment. Engineers evaluate fire load, access paths, and response timelines. Designs integrate detection, suppression, and control into a single operational logic. The result supports faster response and reduced asset damage.
</p>

<p>
Clients experience smoother audits and consistent system behaviour. Maintenance teams receive documentation that simplifies long term upkeep. This clarity reduces operational stress during emergencies.
</p>

<h2><b>Integrated Fire Protection Engineering And System Design</b></h2>

<p>
Fire protection works best when systems communicate clearly. At Unique Engineers, we design networks where detection triggers response without delay. The design philosophy prioritises coordination across building services.
</p>

<p>
This coordination supports environments linked with an HVAC company in India during integrated projects. Air movement, smoke control, and pressurisation align with fire response planning. Such alignment reduces smoke spread and protects evacuation routes.
</p>

<p>
Electrical layouts receive equal attention. Control panels, cabling, and backup power support uninterrupted operation. The team also collaborates as industrial electrical contractors in India on complex facilities. This coordination prevents electrical failure from undermining fire protection performance.
</p>

<h2><b>Execution Discipline That Protects Operations And People</b></h2>

<p>
Installation quality defines system reliability during emergencies. At Unique Engineers, we follow strict supervision and documented testing protocols. Each installation stage receives verification before progression.
</p>

<p>
This discipline supports projects where a single <a href="https://www.uniqueengineersltd.com/"><b>MEP company in India</b></a> handles multiple services. Fire systems integrate smoothly with plumbing and electrical networks. Clear interface management prevents conflict between systems.
</p>

<p>
The company also delivers as an <a href="https://www.uniqueengineersltd.com/services/air-conditioning-contractor-in-india/"><b>air conditioning contractor in India</b></a> during combined service scopes. Coordination avoids airflow patterns that spread smoke during fires. Such foresight protects occupants and supports safe evacuation.
</p>

<h2><b>Lifecycle Support That Respects Real Operating Conditions</b></h2>

<p>
Fire systems age with the building and its use.At Unique Engineers, we plan for this reality from the design stage. Maintenance access, system testing, and component replacement remain practical.
</p>

<p>
Facilities with changing layouts benefit from adaptable system design. Periodic audits identify evolving risks and system fatigue. This service approach supports compliance without operational disruption.
</p>

<p>
Clients managing large campuses appreciate continuity. The team often works alongside a <a href="https://www.uniqueengineersltd.com/services/mepf-contractor-in-india/"><b>MEPF Contractor in India</b></a> on long term facilities. Shared documentation and service schedules reduce confusion across departments.
</p>

<h3><b>What Sets Unique Engineers Apart In Critical Safety Projects</b></h3>

<p>
At Unique Engineers, we avoid template driven solutions. Each project reflects site behaviour and human movement. The team listens carefully before drawing the first line.
</p>

<p>
Engineering decisions remain transparent and well documented. Clients understand why each system exists and how it functions. This understanding builds trust and improves response discipline during emergencies.
</p>

<p>
The company maintains steady collaboration with industrial <a href="https://www.uniqueengineersltd.com/services/hvac-company-in-india/"><b>hvac contractors in india</b></a> on complex sites. Such cooperation improves smoke management and thermal control strategies. Safety outcomes improve when systems work together.
</p>

<h3><b>Closing Perspective</b></h3>

<p>
Fire safety succeeds through foresight and disciplined engineering. At Unique Engineers, we deliver protection that respects people, processes, and property. Clients gain systems that respond calmly under pressure and remain reliable over time. This approach transforms compliance into genuine preparedness.
</p>


  </section>
</>


                        </div>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item sx={{backgroundColor:'#F4F8FA', mt:'-3em', position:'relative', zIndex:1, px: !isMobile ? 10 : 2.5, width:'100%', display:'flex', justifyContent:'center'}}>
                <Grid item sx={{width:'100%', px: !isMobile ? 10 : 0, pt: !isMobile ? '5em' : '3em', pb: !isMobile ? '5em' : '3em'  }}>
                    <Grid item sx={{}}>
                        <Typography variant='body2' component={'p'} className=' titleStyle title-color' sx={{pb:'1em', textAlign: 'center'}}>Fire safety brings security</Typography>
                        <Grid item sx={{width:'100%', display:'flex', pb: !isMobile && '2em' }}>
                            <Grid item xs={4} sx={{}}>
                                <Typography className=' titleStyle title-color' sx={{pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                    { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="6642212862">1</span>
                                        </span>
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--2" data-fake="0641218062">0</span>
                                        </span>
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--3" data-fake="0692750268">0</span>
                                        </span>
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--4" style={{width:'100%', animation:'none'}} data-fake="+">+</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography variant='body2' component={'p'} className='normal-text' sx={{pb:2, textAlign:'center'}}>Basements <br/>ventilated</Typography>
                            </Grid>
                            <Grid item xs={4} sx={{}}>
                                <Waypoint onEnter={() => setNumberBool(true)} />
                                <Typography className='titleStyle title-color' sx={{pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="5612210038">5</span>
                                        </span>
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--2" data-fake="8639118002">8</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography className='normal-text' sx={{pb:2, textAlign:'center'}}>Industries <br/>provided solutions</Typography>
                            </Grid>
                            <Grid item xs={4} sx={{}}>
                                <Typography className='titleStyle title-color' sx={{pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                    { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="2642210061">2</span>
                                        </span>
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--2" data-fake="5612630828">5</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography className='normal-text' sx={{pb:2, textAlign:'center'}}>Secure <br/>5-star hotel spaces</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {/* <ProjectSlick /> */}
            <FootPrint title='Our projects' imageArray = {slides} content='We offer unique solutions for every project we undertake and our experts examine the details minutely. We also take pride in providing sustainable solutions that minimize our carbon footprint or impact on environment.' />
            <Testimonial title={'Words of satisfaction'}  />


            <> 
            <Grid item  className='title-div'
            // sx={{px:!isMobile ? 10 : 0, width:'100%', maxWidth:1440, display:'flex', justifyContent:'center', pt:'2em'}}
            >
            <Grid item sx={{px: !isMobile && 12.5}}>
            <Grid item xs={12} sx={{pt:'2em', pb: !isMobile ? '8em' : '6em'}}>
            <div container style={{width:'100%', justifyContent:'center', margin:'0px 0px 0px'}}>
            <div class="cussec cusmargnsec1"> 
 
            <h4><b>Frequently Asked Questions</b></h4>

<details open className='cusfq'>
  <summary>What Types Of Facilities Do You Serve?</summary>
  <p>Unique Engineers serves factories, warehouses, hospitals, commercial complexes, and institutional campuses. Each facility receives customised fire protection planning based on operational risk.</p>
</details>

<details className='cusfq'>
  <summary>Do Your Systems Comply With Indian And International Standards?</summary>
  <p>All systems comply with Indian regulations and relevant international fire safety codes. The team ensures smooth statutory approvals and inspection readiness.</p>
</details>

<details className='cusfq'>
  <summary>Can You Integrate Fire Systems With Existing Building Services?</summary>
  <p>Yes, systems integrate with electrical, plumbing, and mechanical services. This integration improves response coordination and long term system reliability.</p>
</details>

<details className='cusfq'>
  <summary>Do You Provide Maintenance And Audits After Installation?</summary>
  <p>Yes, the company provides audits, testing, and maintenance support. These services help systems remain effective as building usage evolves.</p>
</details>

<details className='cusfq'>
  <summary>How Do You Handle High Risk Industrial Environments?</summary>
  <p>Engineers conduct detailed risk assessments before system design. Solutions reflect material hazards, occupancy patterns, and emergency response needs.</p>
</details>


            </div>
            </div>   
            </Grid></Grid></Grid>
            </>


        </Grid>
    </Grid>
)

}

export default FireFighting;